import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let connection_id = useDataValue({
    context: 'connection',
    path: 'id',
    viewPath: props.viewPath,
  })
  let resource_id = useDataValue({
    context: 'connection',
    path: 'current_location_resource.id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      connection_id,
      resource_id,
    },
    pause: !connection_id || !resource_id,
  }
}
